export default {
  pageTitle: '权限管理',
  pageDesc: '管理组织架构和角色权限配置',
  orgTree: '组织架构',
  searchOrg: '搜索组织',
  allExpand: '全部展开',
  allCollapse: '全部收起',
  selectNodeEmpty: '请选择左侧组织架构节点',
  selectNodeHint: '选择不同类型的节点可以进行相应的管理操作',
  selectNodeEmptyV2: '请选择左侧组织架构节点',
  selectNodeHintV2: '选择不同类型的节点可以进行相应的管理操作',
  editInfo: '编辑信息',
  configPermission: '配置权限',
  createCompany: '创建分公司',
  createDepartment: '创建部门',
  createRole: '创建角色',
  chineseName: '中文名称',
  englishName: '英文名称',
  code: '代码',
  departmentCode: '部门编码',
  baseCurrency: '本位币币种',
  country: '所在国家',
  createTime: '创建时间',
  updateTime: '更新时间',
  save: '保存',
  cancel: '取消',
  create: '创建',
  nodeType: {
    group: '集团',
    office: '分公司',
    company: '分公司',
    department: '部门',
    role: '角色'
  },
  permissionConfig: '权限配置',
  permissionConfigTitle: '{name} - 权限配置',
  back: '返回',
  saveConfig: '保存配置',
  authorized: '已授权权限',
  unauthorized: '未授权权限',
  addPermission: '添加权限',
  removePermission: '移除权限',
  operationTip: '勾选权限后使用底部按钮移动，选择子权限时会自动包含父权限',
  permissionName: '权限名',
  permissionClass: '权限类',
  permissionType: '权限型',
  permissionPoint: '权限点',
  modal: {
    editTitle: '编辑信息',
    createTitle: '创建{type}',
    ok: '保存',
    cancel: '取消',
    create: '创建'
  },
  form: {
    chineseName: '中文名称',
    englishName: '英文名称',
    code: '代码',
    departmentCode: '部门编码',
    baseCurrency: '本位币币种',
    country: '所在国家',
    chineseNamePlaceholder: '请输入中文名称',
    englishNamePlaceholder: '请输入英文名称',
    codePlaceholder: '请输入代码',
    departmentCodePlaceholder: '请输入部门编码',
    baseCurrencyPlaceholder: '请输入本位币币种',
    countryPlaceholder: '请选择所在国家',
    chineseNameRequired: '请输入中文名称',
    englishNameRequired: '请输入英文名称',
    codeRequired: '请输入代码',
    departmentCodeRequired: '请输入部门编码',
    countryRequired: '请选择所在国家'
  },
  messages: {
    loadTreeSuccess: '组织架构加载成功',
    loadTreeFail: '组织架构加载失败',
    saveSuccess: '保存成功',
    saveFail: '保存失败',
    createSuccess: '创建成功',
    createFail: '创建失败',
    updateSuccess: '更新成功',
    updateFail: '更新失败',
    deleteSuccess: '删除成功',
    deleteFail: '删除失败',
    configSuccess: '权限配置成功',
    configFail: '权限配置失败',
    confirmDelete: '确定要删除该{type}吗？',
    noNodeSelected: '请先选择节点',
    loading: '加载中...',
    operationFailed: '操作失败',
    networkError: '网络异常，请稍后重试',
    dataAuthSaveSuccess: '数据权限保存成功',
    dataAuthSaveFail: '数据权限保存失败'
  },
  dataAuth: {
    modalTitle: '{name} - 数据权限配置',
    tipText: '配置该功能的数据访问范围。不同数据权限类型对应不同的数据可见范围，多选时数据范围为各层级并集。',
    typeLabel: '数据权限类型（可多选）',
    all: '所有数据',
    allDesc: '可查看系统内所有数据，不受限制',
    allTitle: '所有数据权限',
    branch: '分公司数据',
    department: '部门数据',
    personal: '个人数据',
    selectBranch: '选择分公司',
    selectDepartment: '选择部门',
    selectPersonal: '选择人员',
    branchPlaceholder: '请选择分公司',
    departmentPlaceholder: '请选择部门',
    personalPlaceholder: '请选择人员',
    configBtn: '数据权限',
    configured: '已配置',
    notConfigured: '未配置',
    editConfig: '修改',
    setConfig: '配置',
    revokeAuth: '取消授权',
    revokeConfirmTitle: '确认取消授权',
    revokeConfirmContent: '确定要取消「{name}」的数据权限配置吗？取消后该功能将恢复默认数据访问范围，已保存的权限范围配置将被移除。',
    revokeConfirmOk: '确认取消',
    revokeSuccess: '数据权限授权已取消',
    branchRequired: '请至少选择一个分公司',
    departmentRequired: '请至少选择一个部门',
    personalRequired: '请至少选择一个人员',
    typeRequired: '请至少选择一种数据权限类型'
  }
}
